import SkuEndpoints from "./sku/SkuEndpoints";

export default class TwoDScan {
  constructor(appContext, skuID, scan) {
    this.appContext = appContext;
    this.skuID = skuID;
    this.scan = scan;
  }

  sendEverificationScan() {
    let { appContext, skuID, scan } = this;
    let { state } = appContext;

    return SkuEndpoints.everificationScan(skuID, state.currentSortBoxID, scan)
      .then((res) => {
        if (res.requiresEverification) {
          if (state.scanIDs.includes(res.scanID)) {
            return { success: false, message: "Denna 2D-kod har redan skannats." };
          }
          if (res.scanID && res.scanID > -1) {
            appContext.setState({
              scanIDs: [...state.scanIDs].concat(res.scanID),
            });
          }
        }

        let boxItem = appContext._getNextSortBoxItem(res.skuID);
        boxItem.verifiedQuantity++;
        boxItem.partialQuantity++;

        return new Promise((resolve) => {
          appContext.setState(
            {
              boxItems: state.boxItems.map((bi) => (bi === boxItem ? boxItem : bi)),
            },
            () => resolve({ success: true })
          );
        });
      })
      .catch((e) => {
        return { success: false, message: "Förpackningen är redan skickad." };
      });
  }
}
